// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { infoCardStyles } from "@awc/App/Widgets/InfoCard/InfoCard";
import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { color } from "@awc/XDL/Utilities";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

infoCardStyles.container = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 12px;
    `,
};

infoCardStyles.title = {
    typographyProps: {
        color: "text.link",
        size: fontConfig.fontSize.link,
        weight: fontConfig.weight.bold,
        css: css`
            line-height: ${fontConfig.lineHeight.regular};
        `,
    },
    css: css`
        align-self: baseline;
    `,
};

infoCardStyles.image = {
    css: css`
        img {
            max-width: 100%;
            max-height: 100%;
        }

        box-shadow: 0 1px 3px 2px transparent;
        transition: box-shadow 200ms ease-in-out;
        &:hover {
            box-shadow: 0 1px 3px 2px ${color("primary.main", 0.35)};
        }
    `,
};

infoCardStyles.description = {
    size: fontConfig.fontSize.regular,
    weight: fontConfig.weight.regular,
    lineHeight: fontConfig.lineHeight.regular,
    css: css`
        & > ${TypographyStyle} {
            font-size: inherit;
            font-weight: inherit;
            line-height: inherit;
            margin-bottom: 0;
        }
    `,
};

infoCardStyles.clickableImage = {
    css: css`
    
    `,
};